import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.25 6.5024C2.25 5.68953 2.68845 4.93986 3.39693 4.54134L7.89693 2.01014C8.58185 1.62488 9.41815 1.62488 10.1031 2.01014L14.6031 4.54136C15.3116 4.93988 15.75 5.68954 15.75 6.50241L15.75 11.4979C15.75 12.3107 15.3116 13.0604 14.6031 13.4589L10.103 15.9901C9.41814 16.3754 8.58187 16.3754 7.89695 15.9902L3.39698 13.4591C2.68847 13.0606 2.25 12.3109 2.25 11.498V6.5024ZM6.37502 9C6.37502 7.55025 7.55028 6.375 9.00002 6.375C10.4498 6.375 11.625 7.55025 11.625 9C11.625 10.4497 10.4498 11.625 9.00002 11.625C7.55028 11.625 6.37502 10.4497 6.37502 9Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }